"use strict";
/**
 * Functions - Built in functions accesible from the evaluator context
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scope = exports.paramType = exports.tag = exports.functions = exports.definitions = exports.momentTz = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const numeral_1 = __importDefault(require("numeral"));
const escape_html_1 = __importDefault(require("escape-html"));
const vlx_types_1 = require("@sundaysky/vlx-types");
const functionDefinition_1 = require("./functionDefinition");
const logger_1 = require("@sundaysky/logger");
const log = (0, logger_1.logger)("functions");
const functionDefinitions = {};
// eslint-disable-next-line max-len
const Iso8601Regex = /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d((?:Z|[+-][01]\d:?[0-5]?\d?))$/;
const WordRegex = /\w[^\-\.]*/g;
const properCaseWord = (word) => {
    return word ? word.charAt(0).toUpperCase() + word.substr(1).toLowerCase() : "";
};
const properCase = (str) => {
    return str.replace(/\w\S*/g, (word) => properCaseWord(word).replace(WordRegex, (word) => properCaseWord(word)));
};
const doesTimeStringHasTimezone = (time) => {
    const match = Iso8601Regex.exec(time);
    return match && match.length === 2 && match[1] !== "";
};
const vlxEqual = (a, b) => {
    let lhs = typeof a === "string" ? a.toLocaleLowerCase() : a;
    let rhs = typeof b === "string" ? b.toLocaleLowerCase() : b;
    return lhs === rhs;
};
const isInvalidDate = (value) => {
    if (moment_timezone_1.default.isMoment(value))
        return false;
    else
        return (value === null || value === undefined || typeof value === "object" || Array.isArray(value));
};
const isInvalidNumber = (num) => {
    return Number.isNaN(num) || num === undefined || num === null || num === "" || num === Array.isArray(num);
};
const handleInputToNumericFunction = (input) => {
    return isInvalidNumber(input) ? 0 : input;
};
const momentTz = (time, timezone, ignoreTz) => {
    const timeStringHasTimezone = doesTimeStringHasTimezone(time);
    log.info(`Timezone was${timeStringHasTimezone ? " " : " not "}found in time string ${time}`);
    if (!ignoreTz && timeStringHasTimezone) {
        const offset = moment_timezone_1.default.parseZone(time).utcOffset();
        return (0, moment_timezone_1.default)(time).utcOffset(offset);
    }
    else {
        const selectedTimeZone = timezone ? timezone : "America/New_York";
        log.info(`Using timezone ${selectedTimeZone}${timezone ? "" : " [default]"}`);
        return moment_timezone_1.default.tz(time, selectedTimeZone).tz(selectedTimeZone);
    }
};
exports.momentTz = momentTz;
const moveToTimezone = (date1, timezone) => {
    return (0, exports.momentTz)(date1.format("YYYY-MM-DDTHH:mm:ssZ"), timezone, true);
};
const ignoreTimeOfDay = (date1AtTimezone, timezone) => {
    return (0, exports.momentTz)(date1AtTimezone.format("YYYY-MM-DDT00:00:00Z"), timezone, true);
};
functionDefinitions["v1"] = [
    new functionDefinition_1.FunctionBuilder("substring")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "start position"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "end position"))
        .withFunc((a, b, c) => a ? a.substring(b, c) : null)
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("removeDelimToEnd")
        .withText("remove from delimiter to end")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "delimiters (e.g abc, -!)"))
        .withFunc((a, b) => a ? a.split(b)[0] : null)
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("removeStartToDelim")
        .withText("remove from beginning to delimiter")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "delimiters (e.g abc, -!)"))
        .withFunc((a, b) => (a ? a.substr((a.indexOf(b) >= 0 ? a.indexOf(b) + b.length : 0), a.length) : null))
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("replace")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "replace"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "with"))
        .withFunc((str, replaceVal, withVal) => str ? str.split(replaceVal).join(withVal) : null)
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("trim")
        .withText("trim spaces")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => a ? a.trim() : null)
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("camelcase")
        .withText("Proper Case")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => properCase(a))
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("capitalize")
        .withText("Sentence Case")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => a ? a.charAt(0).toUpperCase() + a.slice(1) : null)
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("uppercase")
        .withText("upper case")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => a ? a.toUpperCase() : null)
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("lowercase")
        .withText("lower case")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => a ? a.toLowerCase() : null)
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("contains")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "string"))
        .withFunc((a, b) => (a) && a.toString().indexOf(b) > -1)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("exists")
        // TODO validate color input. use isValidColor from hub?
        .withInput(vlx_types_1.PARAMTYPE.String, vlx_types_1.PARAMTYPE.Numeric, vlx_types_1.PARAMTYPE.Date, vlx_types_1.PARAMTYPE.URL, vlx_types_1.PARAMTYPE.Color)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((a) => a || a === 0 ? true : false)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("not-exists")
        // TODO validate input. use isValidColor from hub?
        .withText("does not exist")
        .withInput(vlx_types_1.PARAMTYPE.String, vlx_types_1.PARAMTYPE.Numeric, vlx_types_1.PARAMTYPE.Date, vlx_types_1.PARAMTYPE.URL, vlx_types_1.PARAMTYPE.Color)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc(a => !a ? true : false)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("equals")
        .withInput(vlx_types_1.PARAMTYPE.String, vlx_types_1.PARAMTYPE.Numeric, vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Any, "any"))
        .withFunc(vlxEqual)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("notEquals")
        .withText("not equals")
        .withInput(vlx_types_1.PARAMTYPE.String, vlx_types_1.PARAMTYPE.Numeric, vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Any, "any"))
        .withFunc((a, b) => !vlxEqual(a, b))
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("length")
        .withText("# of chars")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withFunc((a) => (a && typeof a === "string") ? a.length : 0)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("add")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "amount"))
        .withFunc((a, b) => handleInputToNumericFunction(a) + handleInputToNumericFunction(b))
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("subtract")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "amount"))
        .withFunc((a, b) => handleInputToNumericFunction(a) - handleInputToNumericFunction(b))
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("absdiff")
        .withText("absolute difference")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "amount"))
        .withFunc((a, b) => Math.abs(handleInputToNumericFunction(a) - handleInputToNumericFunction(b)))
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("multiply")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "amount"))
        .withFunc((a, b) => {
        const num = handleInputToNumericFunction(a) * handleInputToNumericFunction(b);
        return (Object.is(num, -0)) ? 0 : num;
    })
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("integerpart")
        .withText("integer part")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withFunc((input) => Math.trunc(handleInputToNumericFunction(input)))
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("fractionalpart")
        .withText("fractional part")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "digits"))
        .withFunc((input, digits) => {
        let fixed = handleInputToNumericFunction(input).toFixed(digits ? digits : 2);
        return Number(fixed.substring(fixed.indexOf(".") + 1));
    })
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("defaultnumberformat")
        .withText("number")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "decimal digits"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Boolean, "trailing zeros", ["Hide trailing zeros", "Show trailing zeros"], false))
        .withFunc((input, digits, showTrailingZeros) => {
        if (isInvalidNumber(input))
            return "";
        let zeros = Array((digits ? digits : 2) + 1).join("0");
        let format = showTrailingZeros ? `0,0.${zeros}` : `0,0.[${zeros}]`;
        return (0, numeral_1.default)(input).format(format);
    })
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("numberformat")
        .withText("custom")
        .withInput(vlx_types_1.PARAMTYPE.Numeric)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.NumberFormat, "format"))
        .withFunc((input, format) => isInvalidNumber(input) ? "" : (0, numeral_1.default)(input).format(format))
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("datepart")
        .withText("date part")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Choice, "part", ["Day", "Month", "Year"]), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input, part, timezone) => {
        if (isInvalidDate(input))
            return Number.NaN;
        switch (part) {
            case "Day":
                return (0, exports.momentTz)(input, timezone).date();
            case "Month":
                return (0, exports.momentTz)(input, timezone).month() + 1;
            case "Year":
                return (0, exports.momentTz)(input, timezone).year();
            default:
                return 0;
        }
    })
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("dayofweek")
        .withText("day of week")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input, timezone) => isInvalidDate(input) ? "" : (0, exports.momentTz)(input, timezone).format("dddd"))
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("month")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input, timezone) => isInvalidDate(input) ? "" : (0, exports.momentTz)(input, timezone).format("MMMM"))
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("rolldate")
        .withText("roll date")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Date)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Choice, "type", ["Days", "Months", "Years"]), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Numeric, "amount"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input, type, amount, timezone) => {
        if (isInvalidDate(input))
            return null;
        switch (type) {
            case "Days":
            case "Months":
            case "Years":
                return (0, exports.momentTz)(input, timezone).add(amount, type.toLowerCase());
            default:
                return (0, exports.momentTz)(input, timezone);
        }
    })
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("datediff")
        .withText("date diff")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Choice, "units", ["Days", "Months", "Years"]), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Date, "toDate"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input1, units, input2, timezone) => {
        if (isInvalidDate(input1) || isInvalidDate(input2))
            return Number.NaN;
        let date1 = (0, exports.momentTz)(input1, timezone);
        let date2 = (0, exports.momentTz)(input2, timezone);
        switch (units) {
            case "Days": {
                // move to the common timezone
                let date1AtTimezone = moveToTimezone(date1, timezone);
                let date2AtTimezone = moveToTimezone(date2, timezone);
                // Ignoring time of day
                let d1 = ignoreTimeOfDay(date1AtTimezone, timezone);
                let d2 = ignoreTimeOfDay(date2AtTimezone, timezone);
                return Math.abs(d1.diff(d2, "days"));
            }
            case "Months": {
                // Ignoring day in month
                return Math.abs((date1.year() * 12 + date1.month()) - (date2.year() * 12 + date2.month()));
            }
            case "Years": {
                // Ignoring month
                return Math.abs(date1.year() - date2.year());
            }
            default:
                return 0;
        }
    })
        .withTag(vlx_types_1.TAG.Function)
        .build(),
    new functionDefinition_1.FunctionBuilder("dateformat")
        .withText("date format")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.DateTimeFormat, "format"), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.TimeZone, "timeZone"))
        .withFunc((input, format, timezone) => isInvalidDate(input) ? "" : (0, exports.momentTz)(input, timezone).format(format))
        .withTag(vlx_types_1.TAG.Formatter)
        .build(),
    new functionDefinition_1.FunctionBuilder("isDateBefore")
        .withText("is before")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Date))
        .withFunc((a, b) => (isInvalidDate(a) || isInvalidDate(b)) ? false : (0, exports.momentTz)(a).isBefore((0, exports.momentTz)(b)))
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("isDateAfter")
        .withText("is after")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Date))
        .withFunc((a, b) => (isInvalidDate(a) || isInvalidDate(b)) ? false : (0, exports.momentTz)(a).isAfter((0, exports.momentTz)(b)))
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("isBetweenDates")
        .withText("is between")
        .withInput(vlx_types_1.PARAMTYPE.Date)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Date), (0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.Date))
        .withFunc((a, b, c) => {
        if (isInvalidDate(a) || isInvalidDate(b) || isInvalidDate(c))
            return false;
        let date = (0, exports.momentTz)(a);
        let date1 = (0, exports.momentTz)(b);
        let date2 = (0, exports.momentTz)(c);
        return (date.isSame(date1) || date.isSame(date2) || (date.isAfter(date1) && date.isBefore(date2)));
    })
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("istrue")
        .withText("is true")
        .withInput(vlx_types_1.PARAMTYPE.Boolean)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((a) => a && a != "false")
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("isfalse")
        .withText("is false")
        .withInput(vlx_types_1.PARAMTYPE.Boolean)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((a) => !(a) || a == "false")
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("listLength")
        .withText("# of valid slots")
        .withInput(vlx_types_1.PARAMTYPE.List)
        .withOutput(vlx_types_1.PARAMTYPE.Numeric)
        .withFunc((list) => list && Array.isArray(list) ? list.length : 0)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("listIncludes")
        .withText("includes")
        .withInput(vlx_types_1.PARAMTYPE.List)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "candidate name"))
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((list, input) => list && Array.isArray(list) ? list.includes(input) : false)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("listDoesntInclude")
        .withText("does not include")
        .withInput(vlx_types_1.PARAMTYPE.List)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "candidate name"))
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((list, input) => list && Array.isArray(list) ? !list.includes(input) : true)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("slotExists")
        .withText("is filled")
        .withInput(vlx_types_1.PARAMTYPE.ListItem)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc(a => !!a)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("slotDoesntExist")
        .withText("is empty")
        .withInput(vlx_types_1.PARAMTYPE.ListItem)
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc(a => !a)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("isFilledWith")
        .withText("is filled with")
        .withInput(vlx_types_1.PARAMTYPE.ListItem)
        .withParams((0, functionDefinition_1.param)(vlx_types_1.PARAMTYPE.String, "candidate name"))
        .withOutput(vlx_types_1.PARAMTYPE.Boolean)
        .withFunc((slot, candidateName) => slot === candidateName)
        .withTag(vlx_types_1.TAG.Operator)
        .build(),
    new functionDefinition_1.FunctionBuilder("escapeHtml")
        .withText("escape html")
        .withInput(vlx_types_1.PARAMTYPE.String)
        .withOutput(vlx_types_1.PARAMTYPE.String)
        .withFunc((a) => a ? (0, escape_html_1.default)(a) : null)
        .withTag(vlx_types_1.TAG.Function)
        .build()
];
const latestVer = "v1";
/**
 * Export:
 * -definitions: A flat array of all functions, including all metadata
 * -functions(version): just the runnable functions, as a map
 */
exports.definitions = functionDefinitions[latestVer];
const functions = (version) => {
    if (!version || version === "latest") {
        version = latestVer;
    }
    return (0, functionDefinition_1.asFunctions)(functionDefinitions[version]);
};
exports.functions = functions;
exports.tag = vlx_types_1.TAG;
exports.paramType = vlx_types_1.PARAMTYPE;
exports.scope = vlx_types_1.SCOPE;
//# sourceMappingURL=functions.js.map